import request from '@/utils/request'
import qs from 'qs'

export function getManagerList(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/getManagerList',
        method: 'post',
        data
    })
}

export function getRoleList(data) {
    data = qs.stringify(data)
    return request({
        url: '/sys/role/getRoleList',
        method: 'post',
        data
    })
}

export function deleteAdmin(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/deleteManager',
        method: 'post',
        data
    })
}
export function checkUserNameApi(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/checkUserName',
        method: 'post',
        data
    })
}

export function addManage(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/addManage',
        method: 'post',
        data
    })
}

export function resetPwd(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/resetPwd',
        method: 'post',
        data
    })
}

export function updateManage(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/updateManage',
        method: 'post',
        data
    })
}

export function deleteRole(data) {
    data = qs.stringify(data)
    return request({
        url: '/sys/role/deleteRole',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/admin.js